import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card seq-card mb-5"
}
const _hoisted_2 = { class: "card-body py-10 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-gray-600 mb-0"
}
const _hoisted_4 = {
  key: 1,
  class: "text-gray-600 mb-0"
}
const _hoisted_5 = {
  key: 2,
  class: "text-gray-600 mb-0"
}
const _hoisted_6 = {
  key: 1,
  class: "card seq-card mb-5"
}
const _hoisted_7 = { class: "card-header border-0 pt-5" }
const _hoisted_8 = { class: "card-title align-items-center" }
const _hoisted_9 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Leader's Toolkit", -1)
const _hoisted_11 = { class: "card-body py-3" }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-primary d-flex align-items-center mb-5"
}
const _hoisted_13 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" Create folders to organize your leader's toolkit. Open a folder, then use "),
    /*#__PURE__*/_createVNode("strong", null, "Upload File"),
    /*#__PURE__*/_createTextVNode(" or "),
    /*#__PURE__*/_createVNode("strong", null, "Add Link"),
    /*#__PURE__*/_createTextVNode(" to add content. Supported types: images, videos, PDF, Excel, Word, and text documents. Team storage limit: "),
    /*#__PURE__*/_createVNode("strong", null, "1 GB total"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_15 = { class: "d-flex flex-wrap flex-stack mb-4" }
const _hoisted_16 = { "aria-label": "breadcrumb" }
const _hoisted_17 = { class: "breadcrumb breadcrumb-line text-muted fs-6 fw-bold mb-0" }
const _hoisted_18 = { class: "breadcrumb-item" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "d-flex align-items-center gap-3 my-2" }
const _hoisted_21 = { class: "text-muted fs-7" }
const _hoisted_22 = { class: "progress h-8px w-150px" }
const _hoisted_23 = {
  key: 1,
  class: "d-flex flex-wrap gap-2 mb-6"
}
const _hoisted_24 = { class: "btn btn-sm btn-light-primary mb-0" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Upload File ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Publish to Social ")
const _hoisted_27 = {
  key: 2,
  class: "text-center text-muted py-10"
}
const _hoisted_28 = {
  key: 3,
  class: "row g-6 g-xl-9 mb-6"
}
const _hoisted_29 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background":"rgba(0,0,0,0.4)"}
}
const _hoisted_30 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_31 = { class: "modal-content" }
const _hoisted_32 = { class: "modal-header" }
const _hoisted_33 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "New Folder", -1)
const _hoisted_34 = { class: "modal-body" }
const _hoisted_35 = { class: "modal-footer" }
const _hoisted_36 = {
  key: 1,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background":"rgba(0,0,0,0.4)"}
}
const _hoisted_37 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = { class: "modal-header" }
const _hoisted_40 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Add Link", -1)
const _hoisted_41 = { class: "modal-body" }
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Name", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "URL", -1)
const _hoisted_45 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_router_link = _resolveComponent("router-link")
  const _component_KTFolder = _resolveComponent("KTFolder")
  const _component_KTFile = _resolveComponent("KTFile")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 8,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", null, [
      (!_ctx.canViewTeamMaterials)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              (_ctx.isTeamLeader)
                ? (_openBlock(), _createBlock("p", _hoisted_3, " Leader's Toolkit is not available until a team is assigned to your account. "))
                : (_ctx.hasAvailableUplineTeams)
                  ? (_openBlock(), _createBlock("p", _hoisted_4, " Select an upline team in Profile settings to view leader's toolkit. "))
                  : (_openBlock(), _createBlock("p", _hoisted_5, " Leader's Toolkit are not available for your account yet. "))
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("h3", _hoisted_8, [
                _createVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Files/Folder.svg" })
                ]),
                _hoisted_10
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              (_ctx.canManageTeamMaterials)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
                    ]),
                    _hoisted_14
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", null, [
                  _createVNode("nav", _hoisted_16, [
                    _createVNode("ol", _hoisted_17, [
                      _createVNode("li", _hoisted_18, [
                        _createVNode("a", {
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openFolder(0)), ["prevent"]))
                        }, "Root")
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (crumb) => {
                        return (_openBlock(), _createBlock("li", {
                          key: crumb.id,
                          class: ["breadcrumb-item", { active: crumb.id === _ctx.currentParentId }]
                        }, [
                          (crumb.id !== _ctx.currentParentId)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.openFolder(crumb.id)), ["prevent"])
                              }, _toDisplayString(crumb.name), 9, ["onClick"]))
                            : (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(crumb.name), 1))
                        ], 2))
                      }), 128))
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.formatStorageBytes(_ctx.storageUsedBytes)) + " / " + _toDisplayString(_ctx.formatStorageBytes(_ctx.storageLimitBytes)), 1),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", {
                      class: "progress-bar",
                      role: "progressbar",
                      style: { width: _ctx.storagePercent + '%' },
                      "aria-valuenow": _ctx.storagePercent,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 12, ["aria-valuenow"])
                  ])
                ])
              ]),
              (_ctx.canManageTeamMaterials)
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNewFolderModal = true))
                    }, " New Folder "),
                    _createVNode("label", _hoisted_24, [
                      _hoisted_25,
                      _createVNode("input", {
                        type: "file",
                        class: "d-none",
                        accept: _ctx.TEAM_MATERIAL_ACCEPT,
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                      }, null, 40, ["accept"])
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light-primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddLinkModal = true))
                    }, " Add Link "),
                    _createVNode(_component_router_link, {
                      to: "/settings/ai247-portal?tab=publish",
                      class: "btn btn-sm btn-light-success"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.items.length === 0)
                ? (_openBlock(), _createBlock("div", _hoisted_27, " This folder is empty. "))
                : (_openBlock(), _createBlock("div", _hoisted_28, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                      return (_openBlock(), _createBlock(_Fragment, {
                        key: item.id
                      }, [
                        (item.itemType === 'folder')
                          ? (_openBlock(), _createBlock(_component_KTFolder, {
                              key: 0,
                              "folder-name": item.name,
                              files: item.childCount || 0,
                              "can-manage": _ctx.canManageTeamMaterials,
                              onOpen: ($event: any) => (_ctx.openFolder(item.id, item.name)),
                              onRename: ($event: any) => (_ctx.promptRename(item)),
                              onDelete: ($event: any) => (_ctx.confirmDelete(item))
                            }, null, 8, ["folder-name", "files", "can-manage", "onOpen", "onRename", "onDelete"]))
                          : (_openBlock(), _createBlock(_component_KTFile, {
                              key: 1,
                              "file-title": item.name,
                              "file-type": _ctx.fileIconType(item),
                              "created-at": _ctx.formatDate(item.createdAt),
                              "can-manage": _ctx.canManageTeamMaterials,
                              "can-publish": _ctx.canManageTeamMaterials && _ctx.isPublishableItem(item),
                              onOpen: ($event: any) => (_ctx.openItem(item)),
                              onRename: ($event: any) => (_ctx.promptRename(item)),
                              onDelete: ($event: any) => (_ctx.confirmDelete(item)),
                              onPublish: ($event: any) => (_ctx.publishItem(item))
                            }, null, 8, ["file-title", "file-type", "created-at", "can-manage", "can-publish", "onOpen", "onRename", "onDelete", "onPublish"]))
                      ], 64))
                    }), 128))
                  ]))
            ])
          ]))
    ], 512), [
      [_vShow, !_ctx.loading]
    ]),
    (_ctx.showNewFolderModal)
      ? (_openBlock(), _createBlock("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showNewFolderModal = false))
                })
              ]),
              _createVNode("div", _hoisted_34, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.newFolderName = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "Folder name"
                }, null, 512), [
                  [_vModelText, _ctx.newFolderName]
                ])
              ]),
              _createVNode("div", _hoisted_35, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showNewFolderModal = false))
                }, "Cancel"),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.createFolder && _ctx.createFolder(...args)))
                }, "Create")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAddLinkModal)
      ? (_openBlock(), _createBlock("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            _createVNode("div", _hoisted_38, [
              _createVNode("div", _hoisted_39, [
                _hoisted_40,
                _createVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showAddLinkModal = false))
                })
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.linkName = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: "Link name"
                  }, null, 512), [
                    [_vModelText, _ctx.linkName]
                  ])
                ]),
                _createVNode("div", null, [
                  _hoisted_44,
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.linkUrl = $event)),
                    type: "url",
                    class: "form-control",
                    placeholder: "https://..."
                  }, null, 512), [
                    [_vModelText, _ctx.linkUrl]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_45, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showAddLinkModal = false))
                }, "Cancel"),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addLink && _ctx.addLink(...args)))
                }, "Add")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}